<form [formGroup]="userAttributesForm" class="main">
    <div class="select-frequency mt-4">Select Frequency</div>
    <div class="frequency-button-container">
        <div class="col" *ngFor="let frequency of frequencies; let i=index">
            <input type="radio" [id]="i+'max1'" [value]="frequency.value" formControlName="frequency"
                [(ngModel)]="currentFrequency" (change)="onFrequencyChange()">
            <label class="frequency-button" [for]="i+'max1'">{{frequency.key}}</label>
        </div>
    </div>
    <div *ngIf="userAttributesForm.controls.frequency.invalid">
        <span class="error-text">Please select your nCash frequency </span>
    </div>
    <div class="max-amount">
        <p> <span class="">Your Max nCash </span>
            <span class="text-right amount">&#8377;{{ maxNCashAmount | currency:'INR': ''}}</span>
        </p>
    </div>
    <div class="note">
        <p>Note: Based on the frequency selected the Max nCash amount will change</p>
    </div>
    <div class="select-frequency mt-4">Select Date</div>
    <div class="frequency-button-container">
        <div class="col" *ngFor="let date of dates; let i=index">
            <input type="radio" [id]="i+'max2'" [value]="date.value" formControlName="date" [(ngModel)]="currentDate"
                (change)="onDateChange()">
            <label class="frequency-button" [for]="i+'max2'">{{date.key}}<sup>th</sup> of Month</label>
        </div>
    </div>
    <div *ngIf="userAttributesForm.controls.date.invalid">
        <span class="error-text">Please select your nCash date </span>
    </div>
</form>